import { useEffect } from 'react';
import { KLOOK_AID } from '../constants';

export const KlookAffBanner = () => {
  useEffect(() => {
    const id = 'klook-widget-script';
    const old = document.getElementById(id);
    if (old) old.remove();
    const s = document.createElement('script');
    s.id = id; s.async = true;
    s.src = 'https://affiliate.klook.com/widget/fetch-iframe-init.js?t=' + Date.now();
    document.body.appendChild(s);
  }, []);
  return (
    <ins className="klk-aff-widget" data-wid={KLOOK_AID} data-adid="1272946"
         data-actids="46604,11626,73749" data-prod="mul_act" data-price="false"
         data-lang="zh-HK" data-width="160" data-height="600" data-currency="HKD">
      <a href="//www.klook.com/">Klook.com</a>
    </ins>
  );
};

export const KlookDynamicWidget = () => {
  useEffect(() => {
    const id = 'klook-widget-script';
    const old = document.getElementById(id);
    if (old) old.remove();
    const s = document.createElement('script');
    s.id = id; s.async = true;
    s.src = 'https://affiliate.klook.com/widget/fetch-iframe-init.js?t=' + Date.now();
    document.body.appendChild(s);
  }, []);
  return (
    <ins className="klk-aff-widget" data-adid="1273456" data-lang="zh-HK"
         data-currency="HKD" data-cardH="126" data-padding="92" data-lgH="470"
         data-edgeValue="655" data-cid="2" data-tid="2" data-amount="3"
         data-prod="dynamic_widget">
      <a href="//www.klook.com/">Klook.com</a>
    </ins>
  );
};
